import React, { useState } from "react";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import * as bootstrap from "bootstrap";
import { useDispatch } from "react-redux";
import "react-phone-input-2/lib/bootstrap.css";
import "../../../Modules/Order/OrderViewStyle.css";
import {
  EditOrderDetails,
  getSingleOrderView,
} from "../../../../redux/Order/action";
import { FaPencilAlt } from "react-icons/fa";

const EditPhoneNumber = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      country_code: props.order?.country_code || "966",
      contact_number: props.order?.contact_number || "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.country_code || !values.contact_number) {
        errors.phone = "Both country code and number are required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        id: props.id,
        country_code: values.country_code,
        contact_number: values.contact_number,
      };
      const result = await dispatch(EditOrderDetails(payload, setLoading));

      bootstrap.Modal.getInstance(document.getElementById("phoneModal"))?.hide();
      formik.resetForm();
      if (result?.ok) {
        dispatch(getSingleOrderView(props.id));
        props.onSaved?.();
      }
    },
  });

  return (
    <>
      <button
        type="button"
        aria-label="Edit Phone Number"
        className="inline-flex items-center justify-center w-7 h-7 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors"
        data-bs-toggle="modal"
        data-bs-target="#phoneModal"
      >
        <FaPencilAlt className="w-3 h-3" />
      </button>

      <div
        className="modal fade"
        id="phoneModal"
        tabIndex="-1"
        aria-labelledby="phoneModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="phoneModalLabel">
                  Edit Phone Number
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="row d-flex gap-2 justify-content-center align-items-center">
                  {/* Country Code Selector */}
                  <div className="col-4">
                  <PhoneInput
  country={"sa"}
  value={formik.values.country_code}
  onChange={(value, data) => {
    formik.setFieldValue("country_code", data.dialCode);
  }}
  inputProps={{ readOnly: true }}
  inputStyle={{
    paddingLeft: "38px",
    paddingRight: "8px",
  }}
/>
                  </div>

                  {/* Mobile Number Input */}
                  <div className="col-7">
                  <input
  type="number"
  name="contact_number"
  className="form-control"
  placeholder="Mobile number"
  value={formik.values.contact_number}
  onChange={formik.handleChange}
/>
                  </div>
                </div>

                {formik.errors.phone && (
                  <div className="text-danger mt-2 small text-center">
                    {formik.errors.phone}
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPhoneNumber;
